(function($){

  function gc()
  {
    var v = $.cookie( window.surl );

    if( !v )
    {
      return false; 
    }

    v = v.split( ',' );

    if( !$.isArray( v ) )
    {
      return false; 
    }

    return v;

  }
  jQuery( function( $ ) {

    var v = gc();

    if( !v )
    {
      return false; 
    }

    var 
    tmpl = $( '[data-tmpl="wishlist-item"]' )
    ,pi = 0
    ,mpi = v.length
    ;

    function r( items )
    {
      var rs = $( '[data-tmpl="wishlist-item"]' ).not('.hidden' );

      $.each( items, function( i, h ) {
        var a = rs.find( '.cart__image[href="/products/' + h + '"]' )
        ,f = a.first()
        ;
        f.closest( '[data-tmpl="wishlist-item"]' ).find( '[data-field="qty"]' ).val( a.length );
        a.not(f).each( function() {
          $( this ).closest( '[data-tmpl="wishlist-item"]' ).remove();
        } );
      } ); 
    }

    $.each( v, function( i, h ) {
      v && $.getJSON( '/products/' + h + '.json', function( rs ) {
        if( !rs )
        {
          return false; 
        }
        rs = rs.product;
        var tpl = tmpl.clone();
        tpl.find( '[data-field="url"]' ).each( function() {
          $( this ).attr( 'href', '/products/' + h );
        } );
        tpl.find( '[data-field="title"]' ).html( rs.title );
        tpl.find( '[data-field="handle"]' ).attr( 'href', h );
        tpl.find( '[data-field="image"]' ).attr( 'src', rs.image.src );
        if( rs.variants && rs.variants.length )
        {
          tpl.find( '[data-field="price"]' ).html( Shopify.formatMoney(rs.variants[0].price) );
        }
        tpl.removeClass( 'hidden' ).insertBefore( tmpl );
      } ).done( function() {
        pi ++;
        if( mpi == pi )
        {
          r( v );
          $('.cart__header-labels').removeClass( 'hidden' );
        }
      } );
    } );

  } );

  jQuery( function( $ ) {
    $( document ).delegate( '[data-action="remove-wishlist-item"]', 'click', function() {

      var v = gc();

      if( !v )
      {
        return false; 
      }

      var 
      e = $( this )
      ,m = e.attr( 'href' )
      ;

      $.each( v, function( i, h ) {
        if( h == m )
        {
          v.splice( i, 1 ); 
          e.remove();
        }
      } );

      if( v.length == 0 )
      {
        $.removeCookie( window.surl, { path: '/' } );
      }
      else
      {
        $.cookie( window.surl, v.join(','), { path: '/' } );
      }

      if( !v.length )
      {
        $('.cart__header-labels').addClass( 'hidden' ); 
      }

      window.location.reload();


      return false;
    } );
  } );
})(jQuery);